import api from "@api"
import { useStore } from "@stores"
import hasAccess from "@api/hasAccess"
import { useAppContext } from "@components/AppContext"


export const indexOperation = api.get("notifications/ListTemplates")


const useProjectTemplatesStore = (projectId) => {
  const { request, identity } = useAppContext()
  const { id: organizationId } = identity.organization

  const canReadTemplates = hasAccess(["templates-read"])
  const shouldAutoLoad = canReadTemplates

  const parameters = { projectId }
  const dependencies = [ organizationId, projectId ]

  const {
    indexItems: indexProjectTemplates,
    items: templates = [],
  } = useStore(indexOperation.id, request, shouldAutoLoad, parameters, dependencies)

  const getTemplatebyKey = key =>
    (templates || []).find(item => item.key === key)

  const isProjectClosedNonFundEnabled = () => {
    const key = 'PROJECT_CLOSED_NON_FUND'
    const template = getTemplatebyKey(key)

    return template.isEnabled
  }

  const isInvestmentFunded = () => {
    const key = 'INVESTMENT_FUNDED'
    const template = getTemplatebyKey(key)

    return template.isEnabled
  }

  const isInvestmentSigned = () => {
    const key = 'INVESTMENT_SIGNED'
    const template = getTemplatebyKey(key)

    return template.isEnabled
  }

  const isInvestmentRejectedDeadlinePassed = () => {
    const key = 'INVESTMENT_REJECTED_DEADLINE_PASSED'
    const template = getTemplatebyKey(key)

    return template.isEnabled
  }

  const isInvestmentRejectedNotInterested = () => {
    const key = 'INVESTMENT_REJECTED_NOT_INTERESTED'
    const template = getTemplatebyKey(key)

    return template.isEnabled
  }

  const isInvestmentRejectedNoAccreditation = () => {
    const key = 'INVESTMENT_REJECTED_NO_ACCREDITATION'
    const template = getTemplatebyKey(key)

    return template.isEnabled
  }

  const isProjectFileCreated = () => {
    const key = 'PROJECT_FILE_CREATED'
    const template = getTemplatebyKey(key)

    return template.isEnabled
  }

  const isInvestorFileCreated = () => {
    const key = 'INVESTOR_FILE_CREATED'
    const template = getTemplatebyKey(key)

    return template.isEnabled
  }

  return {
    isInvestmentFunded,
    isInvestmentSigned,
    isProjectFileCreated,
    indexProjectTemplates,
    isInvestorFileCreated,
    isProjectClosedNonFundEnabled,
    isInvestmentRejectedNotInterested,
    isInvestmentRejectedDeadlinePassed,
    isInvestmentRejectedNoAccreditation,
  }
}

export default useProjectTemplatesStore
